export enum GtmEvent {
  viewItem = 'view_item',
  addToCart = 'add_to_cart',
  removeFromCart = 'remove_from_cart',
  beginCheckout = 'begin_checkout',
  purchase = 'purchase',
  addPaymentInfo = 'add_payment_info',
  addShippingInfo = 'add-shipping-info',
}
